import { Alert } from '@mui/material';
import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiErrorWarningLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { Customer } from '@clients/customersClient';
import useAddPhone from '@hooks/queries/useAddPhone';

import PhoneForm from './PhoneForm';

interface UserAddModalProps {
    account_id: number;
    customer?: Customer;
    onClickClose: () => void;
    onRefetch?: () => void;
}

const PhoneAddModal = ({
    account_id,
    customer,
    onClickClose,
    onRefetch,
}: UserAddModalProps) => {
    const defaultValues = {
        type: '',
        countryCode: '',
        areaCode: '',
        number: '',
        extension: '',
    };

    const { theme } = useTheme();

    const { mutate, isLoading } = useAddPhone(account_id, customer.id, () => {
        handleCloseForm();
        onRefetch();
    });

    const handleCloseForm = () => {
        onClickClose();
    };

    return (
        <PDialog
            open
            dialogTitle={
                <FormattedMessage
                    id="phoneAddDialog.title"
                    defaultMessage="Add new contact details"
                />
            }
            dialogSubtitle={
                <FormattedMessage
                    id="phoneAddDialog.subtitle"
                    defaultMessage="You can add a new contact by completing the fields below then clicking save. "
                />
            }
            onClose={handleCloseForm}>
            <Alert
                severity="warning"
                sx={{ mx: 3, mb: 1 }}
                icon={
                    <RiErrorWarningLine color={theme?.palette?.warning?.main} />
                }>
                <FormattedMessage
                    id="phoneAddDialog.warningInfo"
                    defaultMessage="This will replace the current active number for that
                            type."
                />
            </Alert>
            <PhoneForm
                onClickClose={handleCloseForm}
                mutate={mutate}
                isLoading={isLoading}
                defaultValues={defaultValues}
            />
        </PDialog>
    );
};

export default PhoneAddModal;
